import { Box, Typography, styled } from '@mui/material';

export const ModalContent = styled(Box)(({ theme }) => ({
	paddingBlock: theme.spacing(1),
}));

export const StudentCard = styled(Box)(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	gap: theme.spacing(2),
	padding: theme.spacing(1.25),
	borderRadius: '16px',
	background: 'linear-gradient(180deg, #ffffff 0%, #f5f7fb 100%)',
	boxShadow: '0px 16px 38px -24px rgba(16, 39, 75, 0.35)',
	cursor: 'pointer',
	transition: 'transform 120ms ease, box-shadow 120ms ease, background 120ms ease',
	'&[data-selected="true"]': {
		background: 'linear-gradient(180deg, #f2f7ff 0%, #e9f1ff 100%)',
		boxShadow: '0px 18px 44px -26px rgba(16, 39, 75, 0.4)',
	},
	'&:active': {
		transform: 'scale(0.99)',
	},
}));

export const StudentInfo = styled(Box)({
	display: 'flex',
	flexDirection: 'column',
	gap: 4,
	minWidth: 0,
});

export const StudentName = styled(Typography)(({ theme }) => ({
	fontWeight: 700,
	lineHeight: 1.3,
	color: theme.palette.text.primary,
}));

export const StudentSubtitle = styled(Typography)(({ theme }) => ({
	fontSize: '14px',
	lineHeight: 1.2,
	color: theme.palette.text.secondary,
}));
